import request from './core/request'
import API_DOMAINS from './core/config'

// 首页
export default {
	//获取所有启用的币种
	getCurreny: (carouselType) => request.get(`/currencyRate/active`, {}, {
		baseURL: API_DOMAINS.manager,
		needAccessToken: false
	}),
	//获取首页轮播图
	getBanner: (carouselType) => request.get(`/setting/common/enabled/${carouselType}`, {}, {
		needAccessToken: false,
	}),
	//获取代购平台
	getPlatform: () => request.get(`/goods/goods/platform`, {}, {
		needAccessToken: false,
	}),
}